// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../flags/tbd.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../flags/cis.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../flags/arabsat.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../flags/nato.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../flags/ussr.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../flags/esa.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../flags/eu.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../flags/eumetsat.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../flags/eutelsat.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../flags/inmarsat.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../flags/intelsat.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../flags/iss.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../flags/rascom.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-unknown {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.fi-cis {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.fi-i-arab {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.fi-nato,
.fi-i-nato {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.fi-su {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.fi-esa,
.fi-i-esa {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.fi-i-eu {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.fi-eume,
.fi-i-eum {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.fi-eute,
.fi-i-eut {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.fi-i-inm,
.fi-im {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.fi-i-int,
.fi-itso {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.fi-iss,
.fi-i-iss {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.fi-rasc,
.fi-i-rasc {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
`, "",{"version":3,"sources":["webpack://./public/css/flag-icons.css"],"names":[],"mappings":"AAAA;IACI,yDAAuC;AAC3C;;AAEA;IACI,yDAAuC;AAC3C;;AAEA;IACI,yDAA2C;AAC/C;;AAEA;;IAEI,yDAAwC;AAC5C;;AAEA;IACI,yDAAwC;AAC5C;;AAEA;;IAEI,yDAAuC;AAC3C;;AAEA;IACI,yDAAsC;AAC1C;;AAEA;;IAEI,yDAA4C;AAChD;;AAEA;;IAEI,yDAA4C;AAChD;;AAEA;;IAEI,yDAA4C;AAChD;;AAEA;;IAEI,0DAA4C;AAChD;;AAEA;;IAEI,0DAAuC;AAC3C;;AAEA;;IAEI,0DAA0C;AAC9C","sourcesContent":[".fi-unknown {\n    background-image: url(../flags/tbd.png);\n}\n\n.fi-cis {\n    background-image: url(../flags/cis.png);\n}\n\n.fi-i-arab {\n    background-image: url(../flags/arabsat.png);\n}\n\n.fi-nato,\n.fi-i-nato {\n    background-image: url(../flags/nato.png);\n}\n\n.fi-su {\n    background-image: url(../flags/ussr.png);\n}\n\n.fi-esa,\n.fi-i-esa {\n    background-image: url(../flags/esa.png);\n}\n\n.fi-i-eu {\n    background-image: url(../flags/eu.png);\n}\n\n.fi-eume,\n.fi-i-eum {\n    background-image: url(../flags/eumetsat.png);\n}\n\n.fi-eute,\n.fi-i-eut {\n    background-image: url(../flags/eutelsat.png);\n}\n\n.fi-i-inm,\n.fi-im {\n    background-image: url(../flags/inmarsat.png);\n}\n\n.fi-i-int,\n.fi-itso {\n    background-image: url(../flags/intelsat.png);\n}\n\n.fi-iss,\n.fi-i-iss {\n    background-image: url(../flags/iss.png);\n}\n\n.fi-rasc,\n.fi-i-rasc {\n    background-image: url(../flags/rascom.png);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
